import(/* webpackMode: "eager", webpackExports: ["LeaguesClientWrapper"] */ "/app/apps/pickleball/src/modules/players/v2/tabs/league/LeaguesClientWrapper.tsx");
